const REACTION_DAILY_LIMIT = 100;

/**
 * JST基準の今日の日付文字列を返す（例: "2026-08-01"）
 */
const getJstDateStr = () => {
  const jstNow = new Date(Date.now() + 9 * 60 * 60 * 1000);
  return jstNow.toISOString().slice(0, 10);
};

/**
 * 今日の「の」リアクション残り回数を返す（全投稿合計）
 * @returns {number} 残り回数（0 = これ以上加算不可）
 */
export const getRemainingReactions = () => {
  const key = `reaction_total_${getJstDateStr()}`;  // postId を含めない
  const count = parseInt(localStorage.getItem(key) ?? '0', 10);
  return Math.max(0, REACTION_DAILY_LIMIT - count);
};

/**
 * リアクション回数を1加算する（上限チェック付き）
 * @returns {boolean} 加算できた場合 true、上限の場合 false
 */
export const consumeReaction = () => {
  const key = `reaction_total_${getJstDateStr()}`;  // postId を含めない
  const count = parseInt(localStorage.getItem(key) ?? '0', 10);
  if (count >= REACTION_DAILY_LIMIT) return false;
  localStorage.setItem(key, String(count + 1));
  return true;
};